import { CommonModule } from '@angular/common';
// Angular Imports
import { NgModule } from '@angular/core';
import { AppNavigationLinksModule } from '../app-navigation-links/app-navigation-links.module';
import { NavigationBookModule } from '../navigation-book/navigation-book.module';
import { NavigationCheckinModule } from '../navigation-checkin/navigation-checkin.module';
import { NavigationFlightStatusModule } from '../navigation-flight-status/navigation-flight-status.module';
import { NavigationMytripsModule } from '../navigation-mytrips/navigation-mytrips.module';
// This Module's Components
import { AppLinksContentMobileContainerComponent } from './app-links-content-mobile-container.component';

@NgModule({
  imports: [
    CommonModule,
    NavigationBookModule,
    NavigationCheckinModule,
    NavigationMytripsModule,
    NavigationFlightStatusModule,
    AppNavigationLinksModule
  ],
  declarations: [AppLinksContentMobileContainerComponent],
  exports: [AppLinksContentMobileContainerComponent]
})
export class AppLinksContentMobileContainerModule {}
